import React from 'react';
import Footer from '../component/Footer';

const Cardiology = () => {
    return (
        <>
            <div className="container">
                {/* Heading Section */}
                <div className="text-center my-5">
                    <h1>Cardiology</h1>
                </div>

                {/* Content Section */}
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            Cardiology focuses on diagnosing, treating, and preventing heart and blood vessel conditions.
                            Our cardiology team is dedicated to providing top-notch care for patients with a range of heart-related issues.
                        </p>
                        <p>
                            We specialize in managing cardiovascular diseases, including heart attacks, arrhythmias, heart failure, 
                            and preventive cardiology to keep your heart healthy.
                        </p>
                        <p>
                            With advanced diagnostic equipment and innovative treatments, we aim to offer personalized care 
                            that improves heart health and overall well-being.
                        </p>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <Footer />
        </>
    );
}

export default Cardiology;
